module.exports = __webpack_public_path__ + "static/media/icon-reports.a04feb44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-reports.svg
// module id = 1222
// module chunks = 19